/* A scoped enhancement of Shopify's native variant picker and product form. */
(() => {
  function init(root) {
    if (root.dataset.elReady) return;
    root.dataset.elReady = 'true';
    const bar = root.querySelector('.el-v2-bar');
    const action = bar.querySelector('[data-el-options]');
    const notice = root.querySelector('.el-v2-availability');
    const guide = root.querySelector('.el-v2-guide');
    const section = root.dataset.section;
    const mobile = matchMedia('(max-width:749px)');
    const events = new AbortController();
    const listen = (node, type, fn, options = {}) => node.addEventListener(type, fn, {...options, signal:events.signal});
    const nativeButton = () => root.querySelector(`#ProductSubmitButton-${section}`);
    const variant = () => {
      const data = root.querySelector('[data-selected-variant]');
      return data ? JSON.parse(data.textContent) : null;
    };
    const write = (node, text) => { if (node.textContent !== text) node.textContent = text; };
    let confirmedSize = null, frame = 0, stateDirty = true, barHeight = 88, guideTrigger, savedScroll = 0;
    function schedule(state = false) {
      stateDirty = stateDirty || state;
      if (!frame) frame = requestAnimationFrame(render);
    }
    function render() {
      frame = 0;
      if (!root.isConnected) { cleanup(); return; }
      if (stateDirty) {
        stateDirty = false;
        const current = variant();
        const picker = root.querySelector('variant-selects');
        const hasSize = !!picker?.querySelector('[data-el-size]');
        const selectedSize = picker?.querySelector('[data-el-size] input:checked')?.value;
        const selection = [...(picker?.querySelectorAll('input:checked, select') || [])].map(i => i.value.trim()).join(' / ');
        const price = root.querySelector('.price--on-sale .price-item--sale') || root.querySelector('.price__regular .price-item');
        write(bar.querySelector('[data-el-bar-price]'), current && price ? price.textContent.trim() : 'Choose options');
        write(bar.querySelector('[data-el-bar-selection]'), !hasSize || confirmedSize === selectedSize ? selection : `${picker?.querySelector('.el-v2-colours input:checked')?.value || ''} · Choose your size`);
        const unavailable = !current || !current.available;
        notice.hidden = !unavailable;
        write(notice, unavailable ? `${selection || 'This combination'} ${current ? 'is sold out' : 'is unavailable'}. Please choose another colour or size.` : '');
        const error = root.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent.trim();
        const ready = (!hasSize || (!!confirmedSize && confirmedSize === selectedSize)) && !unavailable && !error;
        action.dataset.ready = String(ready);
        const button = nativeButton();
        const busy = button?.disabled || button?.getAttribute('aria-disabled') === 'true';
        action.disabled = ready && busy;
        write(action, error ? 'Review selection' : (ready ? (busy ? 'Please wait…' : 'Add to cart') : (unavailable && confirmedSize ? 'Change size' : 'Choose size')));
      }
      if (!mobile.matches) { bar.hidden = true; return; }
      const button = nativeButton();
      if (!button) { bar.hidden = true; return; }
      const box = button.getBoundingClientRect();
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
      const header = document.querySelector('.shopify-section-header-sticky');
      const top = Math.max(viewport?.offsetTop || 0, header ? Math.max(0, header.getBoundingClientRect().bottom) : 0);
      // Use the same reserved strip in both states to prevent a hide/show feedback loop.
      const fullyVisible = box.top >= top && box.bottom <= bottom - barHeight;
      const overlay = [...document.querySelectorAll('cart-notification.active, cart-drawer.active, .menu-opening, .shopify-pc__banner__dialog, product-modal[open], dialog[open]')].some(el => el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden');
      const hidden = fullyVisible || scrollY < 260 || overlay;
      if (bar.hidden !== hidden) bar.hidden = hidden;
    }
    function confirmSize(event) {
      const label = event.target.closest('[data-el-size] label');
      const input = event.target.matches('[data-el-size] input[type=radio]') ? event.target : (label ? document.getElementById(label.htmlFor) : null);
      if (input && !input.classList.contains('disabled')) { confirmedSize = input.value; schedule(true); }
    }
    listen(root, 'click', event => {
      confirmSize(event);
      const link = event.target.closest('[data-el-size-guide]');
      if (link && guide && typeof guide.showModal === 'function') {
        event.preventDefault();
        guideTrigger = link; savedScroll = scrollY;
        if (!guide.dataset.loaded) {
          const local = root.querySelector('[data-el-local-guide]');
          const source = local?.content.querySelector('.auldweave-fit-sizing') ? local : root.querySelector('[data-el-guide-content]');
          guide.querySelector('.el-v2-guide-body').append(source.content.cloneNode(true));
          guide.querySelectorAll('details').forEach(detail => detail.open = true);
          guide.dataset.loaded = 'true';
        }
        guide.showModal();
        document.documentElement.classList.add('el-v2-guide-open');
        guide.querySelector('[data-el-guide-close]').focus({preventScroll:true});
        schedule();
      }
      if (event.target.closest('[data-el-guide-close]')) guide.close();
      if (!event.target.closest('[data-el-options]')) return;
      const button = nativeButton();
      const current = variant();
      const size = root.querySelector('[data-el-size] input:checked')?.value;
      if (action.dataset.ready === 'true' && (!root.querySelector('[data-el-size]') || (confirmedSize && confirmedSize === size)) && current?.available && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        button.click(); // Shopify owns the variant ID, quantity, errors, loading state and cart.
        schedule(true);
      } else {
        const sizes = root.querySelector('.product-form__error-message-wrapper:not([hidden])') || root.querySelector('[data-el-size]') || root.querySelector('variant-selects');
        sizes.scrollIntoView({behavior:'instant', block:'start'});
        sizes.querySelector('input:checked, input')?.focus({preventScroll:true});
      }
    });
    listen(root, 'change', event => { confirmSize(event); schedule(true); });
    listen(root, 'keydown', event => { if ((event.key === ' ' || event.key === 'Enter') && !event.repeat && event.target.matches('[data-el-size] input[type=radio]')) confirmSize(event); });
    listen(guide, 'click', event => {
      if (event.target !== guide) return;
      const rect = guide.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) guide.close();
    });
    listen(guide, 'close', () => {
      document.documentElement.classList.remove('el-v2-guide-open');
      scrollTo({top:savedScroll, behavior:'instant'});
      (guideTrigger?.isConnected ? guideTrigger : root.querySelector('[data-el-size-guide]'))?.focus({preventScroll:true});
      schedule();
    });
    const resize = new ResizeObserver(() => {
      if (!bar.hidden && bar.offsetHeight) barHeight = bar.offsetHeight;
      document.body.style.setProperty('--el-v2-bar-height', `${bar.hidden ? 0 : barHeight}px`);
    });
    resize.observe(bar);
    const changes = new MutationObserver(records => {
      if (records.some(m => (m.type !== 'attributes' || m.attributeName !== 'class' || m.target === nativeButton()) && !bar.contains(m.target) && !notice.contains(m.target) && !guide.contains(m.target))) schedule(true);
    });
    changes.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled','hidden','class']});
    listen(window, 'scroll', () => schedule(), {passive:true});
    listen(window, 'resize', () => schedule());
    if (window.visualViewport) listen(window.visualViewport, 'resize', () => schedule());
    listen(document, 'click', () => schedule());
    listen(document, 'keydown', () => schedule());
    listen(document, 'shopify:section:unload', event => { if (event.target.contains(root)) cleanup(); });
    function cleanup() {
      events.abort(); changes.disconnect(); resize.disconnect(); cancelAnimationFrame(frame);
      if (guide.open) guide.close();
      document.documentElement.classList.remove('el-v2-guide-open');
      document.body.style.removeProperty('--el-v2-bar-height');
    }
    schedule(true);
  }
  const boot = () => document.querySelectorAll('product-info.el-v2').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
